function t(t){var e=this.has(t)&&delete this.__data__[t];return this.size-=e?1:0,e}export{t as default};
//# sourceMappingURL=_hashDelete.js.map
